export default __webpack_public_path__ + "static/media/Clock.0dc5fb96.svg";